import { useContext, useEffect, useState } from "react";
import WelletContext from "../../../context/WelletContext";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../../components/Header/Header";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import ContentApp from "../../../components/ContentApp/ContentApp";
import ReservationTypeCardIcon from "../../../components/ReservationTypeCard/ReservationTypeCardIcon";

const RESTAURANT = "RESTAURANT";
const AREA = "AREA";

const ReservationType = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showUrl } = useParams();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);

  const getTargetPath = (type) => {
    if (type === RESTAURANT) {
      return `/venue/${showUrl}/restaurant-reservation`;
    }
    if (type === AREA) {
      return `/venue/${showUrl}/reservation/area`;
    }
    return null;
  };

  const getTitle = (type) => {
    if (type === RESTAURANT) return t("restaurantTypeName");
    if (type === AREA) return t("VIPareas");
    return null;
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/get/${showUrl}`,
        {
          params: {
            lang: language,
          },
        }
      );

      const data = result.data;
      const types = (
        Array.isArray(data?.reservationTypes) ? data.reservationTypes : []
      ).filter((r) => r.type === RESTAURANT || r.type === AREA);

      // If only one supported type remains, skip the intermediate screen
      // and go straight to the booking flow.
      if (types.length === 1) {
        navigate(getTargetPath(types[0].type), { replace: true });
        return;
      }

      setShow({ ...data, reservationTypes: types });
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    getShow();
  }, []);

  const handleClick = (type) => {
    navigate(getTargetPath(type));
  };

  if (loading) return <LoadingScreen />;
  if (!show) return null;

  return (
    <>
      <Header
        title={
          <div className="text-capitalize px-3">
            {t("book") + " " + show.name}
          </div>
        }
      />
      <ContentApp>
        <div className="px-3 mt-4">
          <div className="fw-bold font-medium mb-3">
            {t("selectReservationType")}
          </div>
          {show.reservationTypes.map((reservation, index) => (
            <div key={reservation.type} className={index === 0 ? "" : "mt-3"}>
              <ReservationTypeCardIcon
                type={reservation.type}
                title={getTitle(reservation.type)}
                onHandleClick={() => handleClick(reservation.type)}
              />
            </div>
          ))}
        </div>
      </ContentApp>
    </>
  );
};

export default ReservationType;
